import { axiosClient } from "@/shared/api/axios-client";

/**
 * Una entrada por cada nivel que el usuario actual autorizó. Si un mismo
 * usuario autorizó múltiples niveles de la misma solicitud (caso raro de
 * coordinador con varios roles), aparecerán múltiples rows con la misma
 * `solicitudId` pero distinto `nivelAutorizado`.
 */
export interface HistorialAutorizacionItem {
  solicitudId: string;
  numeroSolicitud: number;
  /** Folio formateado · 11 chars sin org, 15 chars con org (sociedad + folio). */
  folio: string;
  nivelAutorizado: number;
  cantidadNiveles: number;
  autorizadoAt: string;
  estadoActualSolicitud: string;
  organizacionNombre: string | null;
  tipo: string | null;
  subtipo: string | null;
  totalCfdi: number | null;
  monedaCfdi: string | null;
  /** Fecha de pago (ISO `YYYY-MM-DD`) fijada al autorizar el último nivel · null si aún no. */
  fechaPago: string | null;
  // Columnas de información equivalentes a la bandeja de autorización.
  areaNombre: string | null;
  proveedorRazonSocial: string | null;
  proveedorNumero: number | null;
  rfcEmisor: string | null;
  descripcionPrimerConcepto: string | null;
  fechaCreacion: string;
}

/** KPIs del resumen · calculados en el server sobre el set filtrado completo. */
export interface HistorialAutorizacionesStats {
  completadas: number;
  ultimaAutorizacion: string | null;
}

/** Página del historial · espejo de HistorialPageDto del backend. */
export interface HistorialAutorizacionesPageDto {
  items: HistorialAutorizacionItem[];
  total: number;
  page: number;
  pageSize: number;
  stats: HistorialAutorizacionesStats;
}

/**
 * Listado PAGINADO del historial · los filtros de columna y el paginado
 * (page/pageSize) se resuelven en el SERVIDOR vía query params.
 */
export async function listarHistorialAutorizaciones(
  params: Record<string, string | number> = {},
): Promise<HistorialAutorizacionesPageDto> {
  const { data } = await axiosClient.get<HistorialAutorizacionesPageDto>(
    "/api/autorizacion/historial",
    { params },
  );
  return data;
}
